'use strict';

var fnv1a = require('@sindresorhus/fnv1a');

var stringHash = function stringHash(string) {
  return fnv1a(string);
};

module.exports = stringHash; // TODO: remove this in the next major version

module.exports.default = stringHash;